import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import VueDragDrop from '@/common/drag-and-drop';
import VueEvents from 'vue-plugin-events';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueDragDrop);
Vue.use(VueEvents);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#zoomid-editor');
